import { createFileRoute } from "@tanstack/react-router";
import { PostDetailPage } from "@/features/study-group-stream/components/PostDetailPage";
import { FeedInputProvider } from "@/features/study-group-stream/contexts/FeedInputContext";

const PostDetailRoute = () => (
  <FeedInputProvider>
    <PostDetailPage />
  </FeedInputProvider>
);

export const Route = createFileRoute(
  "/study-group/$study-group-id/post/$post-id",
)({
  component: PostDetailRoute,
});
